import React from 'react'
import styled from '@emotion/styled'
import { ReactComponent as CrossIcon } from '../../../../../assets/icons/app/cross.icon.svg'

const FileStyle = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  gap: 7px;
  background-color: #f7f7f7;
  border-radius: 4px;
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 7px;
  padding-right: 24px;
`

const LabelFileStyle = styled.p`
  overflow: hidden;
  color: #252525;
  font-size: 14px;
  font-weight: 500;
`

const AudienceFileMenuInput = ({
  inputValue,
  handleRemove,
}: {
  inputValue: File | null
  handleRemove: () => void
}) => {
  return (
    <FileStyle>
      <CrossIcon
        style={{
          width: 16,
          height: 16,
        }}
        onClick={handleRemove}
      />
      <LabelFileStyle>{inputValue?.name ?? ''}</LabelFileStyle>
    </FileStyle>
  )
}

export default AudienceFileMenuInput
